import React from 'react';

export const SITE_URL = 'https://easybase64.com';
const OG_IMAGE = `${SITE_URL}/og-image.png`;

interface SeoProps {
  title: string;
  description: string;
  path: string; // e.g. "/base64-decode" ("/" for home)
  // One or more JSON-LD schema objects to embed for rich results.
  jsonLd?: object | object[];
}

// Renders document metadata (title, description, canonical, Open Graph,
// Twitter) plus optional JSON-LD. React 19 hoists these tags into <head>,
// and react-snap serializes them into the prerendered HTML for crawlers.
export default function Seo({ title, description, path, jsonLd }: SeoProps) {
  const canonical = `${SITE_URL}${path === '/' ? '' : path}`;
  const schemas = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={OG_IMAGE} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonical} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={OG_IMAGE} />

      {schemas.map((schema, i) => (
        <script
          key={i}
          type="application/ld+json"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
      ))}
    </>
  );
}
